import { CSSProperties } from 'react';

export default function UserPlaceholder({ s }: { s: CSSProperties }) {
  return (
    <svg
      width="115"
      height="112"
      viewBox="0 0 115 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        d="M100.8 56C100.8 80.7422 80.7421 100.8 55.9999 100.8C31.2578 100.8 11.2 80.7422 11.2 56C11.2 31.2579 31.2578 11.2 55.9999 11.2C80.7421 11.2 100.8 31.2579 100.8 56Z"
        stroke="#250058"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3111 85.9121H23.4722L23.5691 82.8747C23.5691 71.4984 32.7928 62.2747 44.1689 62.2747H67.7254C79.1018 62.2747 88.3254 71.4984 88.3254 82.8744L88.2285 85.9121"
        stroke="#250058"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.3726 32.3814C69.6297 35.0642 70.8649 38.459 70.8596 41.965C70.8596 50.1997 64.1825 56.8768 55.9478 56.8768C47.7131 56.8768 41.036 50.1997 41.036 41.965C41.036 33.7303 47.7116 27.0532 55.9478 27.0532C60.5339 27.0532 64.6365 29.1237 67.3726 32.3814Z"
        stroke="#1399D6"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
